import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SESSIONS_FEATURE_KEY, State } from './steps.reducer';

export const getSessionState = createFeatureSelector<State>(SESSIONS_FEATURE_KEY);

export const getSessionsLoaded = (stepId: string) => createSelector(getSessionState, (state: State) => state.sessions[stepId] ?? []);
export const getEvaluationInstrumentsLoaded = (stepId: string) =>
  createSelector(getSessionState, (state: State) => state.evaluationInstruments[stepId] ?? []);
export const getOtherActivitiesLoaded = (stepId: string) =>
  createSelector(getSessionState, (state: State) => state.otherActivities[stepId] ?? []);
export const isSessionsLoaded = createSelector(getSessionState, (state: State) => state.loaded['sessions']);
export const getUpdateSessions = createSelector(getSessionState, (state: State) => state.updated);
export const getStudentExercisesProgress = createSelector(getSessionState, (state: State) => state?.exercisesProgress);
